import { Components } from "@mui/material";

export const MuiDrawer: Components["MuiDrawer"] = {
  styleOverrides: {
    root: {
      "> .MuiPaper-root": {
        backgroundColor: "#F3F6FA",
      },
    },
  },
};
